'use strict';
const mmWidgets = require('../widgets/mm-widgets');

mmWidgets.fn.nodeLineAttrWidget = function (mapEditorModel) {
	return mmWidgets.each(this, function () {
		const element = this,
			attributeName = element.attr('data-mm-node-line-attr'),
			attributeValue = element.attr('data-mm-node-line-value'),
			showOnAttributeValue = element.attr('data-mm-node-line-show-on'),
			relativeValue = element.attr('data-mm-node-line-value-relative'),
			calcCurrentValue = () => {
				const selectedLine = mapEditorModel.getSelectedLine(),
					attr = mapEditorModel.getSelectedLineAttr() || {},
					defaults = (selectedLine && selectedLine.connectorEditingContext && selectedLine.connectorEditingContext.defaults) || {};
				return attr[attributeName] || defaults[attributeName] || false;
			},
			calcNewValue = () => {
				if (!relativeValue) {
					if (!attributeValue || attributeValue === 'false') {
						return false;
					}
					return attributeValue;
				}
				const newVal = (parseInt(calcCurrentValue()) || 1) + parseInt(attributeValue);
				return Math.max(1, newVal);
			},
			shouldBeShown = () => {
				const current = calcCurrentValue();
				if (showOnAttributeValue !== undefined) {
					return (current === showOnAttributeValue || (!current && showOnAttributeValue === 'false'));
				}
				if (attributeValue === 'false') {
					return !!current;
				}
				return (attributeValue !== current);
			};

		element.click(function () {
			mapEditorModel.updateLineProperty(attributeName, calcNewValue());
		});
		mapEditorModel.addEventListener('lineSelected lineUpdated', function () {
			if (relativeValue) {
				return;
			}
			if (shouldBeShown()) {
				element.removeClass('hidden');
			} else {
				element.addClass('hidden');
			}
		});
	});
};
